import { HostPageEventInput, QueuedHostPageEvent } from './host-page-event.types'

interface HostPageEventQueueProps {
  now?: () => number
}

export default class HostPageEventQueue {
  private eventsByCampaign: Record<string, QueuedHostPageEvent[]> = {}
  private now: () => number
  private sequence = 0

  constructor(props: HostPageEventQueueProps = {}) {
    this.now = props.now || (() => Date.now())
  }

  public record = (event: HostPageEventInput): QueuedHostPageEvent => {
    const capturedAt = this.now()
    const sequence = ++this.sequence
    const queuedEvent: QueuedHostPageEvent = {
      ...event,
      capturedAt,
      id: `${event.campaignId}:${sequence}:${capturedAt}`,
      sequence,
    }

    if (!this.eventsByCampaign[event.campaignId]) {
      this.eventsByCampaign[event.campaignId] = []
    }

    this.eventsByCampaign[event.campaignId].push(queuedEvent)

    return queuedEvent
  }

  public drain = (campaignId: string): QueuedHostPageEvent[] => {
    const queuedEvents = this.peek(campaignId)

    if (queuedEvents.length === 0) {
      return []
    }

    delete this.eventsByCampaign[campaignId]

    return queuedEvents
  }

  public peek = (campaignId: string): QueuedHostPageEvent[] => {
    const queuedEvents = this.eventsByCampaign[campaignId]

    return queuedEvents ? [...queuedEvents] : []
  }

  public reset = (): void => {
    this.eventsByCampaign = {}
    this.sequence = 0
  }
}
